import { render, staticRenderFns } from "./CategoryName.vue?vue&type=template&id=531c0c34&"
import script from "./CategoryName.vue?vue&type=script&lang=js&"
export * from "./CategoryName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports